module.exports = __webpack_public_path__ + "img/card-size.1ed2a1cc.png";